import { combineEpics, Epic, ofType } from 'redux-observable'
import { catchError, map, mergeMap, of } from 'rxjs'
import { getHub } from '../../helpers/hub'
import { logError } from '../ws/actions'
import { clearLogItems, noLogItems } from './actions'
import { getLog } from './selectors'

const logEpic: Epic = (action$, state$) =>
  action$.pipe(
    ofType('log.WriteLogItems'),
    mergeMap(() => {
      const log = getLog(state$.value)
      if (Object.keys(log).length === 0) {
        return of(noLogItems())
      }
      const idsToRemove: number[] = []
      const logItems = []
      for (const key in log) {
        if (log.hasOwnProperty(key)) {
          const keyNum = Number(key)
          idsToRemove.push(keyNum)
          logItems.push(log[key])
        }
      }
      return getHub()
        .invoke<boolean>('LogFromClient', logItems)
        .pipe(
          map((val) => clearLogItems(idsToRemove)),
          catchError((err) => of(logError(err)))
        )
    })
  )

export default combineEpics(logEpic)
